<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item v-if="user && ![2, 3, 4, 5].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" @click="add" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :page="page" :limit="limit"
      :total="total" :showIndex="true" :btns="btns" :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="buttonPD" slot-scope="params">
        <el-button class="dispatchbtn" type="primary" @click="dispatch(params.params)" size="mini">派单</el-button>
      </template>
      <template slot="button" slot-scope="params" v-if="user.user_group_id == 2 || user.id == 323">
        <el-button class="dispatchbtn shbtn" type="warning" @click="checkConfirm(params.params)"
          size="mini">完结</el-button>
      </template>

      <!-- 是否含税 -->
      <template slot="is_tax" slot-scope="params">
        {{ params.params.is_tax == 1 ? '是' : '否' }}
      </template>
    </Table>


    <Dialog class="dialog" ref="dialog" :title="title">
      <template #default>
        <div class="top">
          <el-form class="searchForm" :model="modalSearchForm">
            <FormItem v-for="(c, i) in modalSearchFormCtrl" :key="'msformItem' + i" :viewMode="false" :config="c"
              :options="c.options" :inputValue="modalSearchForm[c.keyName]" @onChange="onSearchFormChange" />

            <el-form-item>
              <el-button type="primary" @click="getCars">搜索</el-button>
            </el-form-item>

            <el-form-item>
              <el-button plain @click="onModalSearchReset">重置</el-button>
            </el-form-item>
          </el-form>

          <el-form class="modalForm" :model="mform">
            <!-- <FormItem v-for="(c, i) in mformCtrl" :key="'mformItem' + i" :viewMode="false" :config="c"
            :options="c.options" :inputValue="mform[c.keyName]" @onChange="onModalChange" /> -->

            <el-checkbox v-model="checked">司机提成</el-checkbox>
          </el-form>
        </div>

        <el-scrollbar class="modal-scroll">
          <el-checkbox-group class="list" v-model="checkedLists" @change="onCheckChange">
            <el-checkbox class="item" v-for="(c, i) in cars" :key="'car' + i" :label="c.id">
              <div class="row0">
                <div class="col0">{{ c.license }}</div>
                <div class="col1">{{ c.driver }}</div>
              </div>
              <div class="row1">
                <div class="col0">挂：</div>
                <div class="col1"></div>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </el-scrollbar>

        <div class="btns">
          <el-button type="primary" @click="modalSubmitConfirm">确 定</el-button>
          <el-button @click="hideDialog">取 消</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'contract',
      formInline: {
        isstatus: 2,
      },
      formCtrl: [
        {
          label: "合同编号",
          keyName: "con_num",
          placeholder: "请填写合同编号",
          type: "text",
        },
        {
          label: "客户名称",
          keyName: "shname",
          placeholder: "请填写客户名称",
          type: "text",
        },
        {
          label: "装货地址",
          keyName: "coaddress",
          placeholder: "请填写装货地址",
          type: "text",
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          placeholder: "请填写卸货地址",
          type: "text",
        },
      ],
      cols: [
        { prop: "con_num", label: "合同编号", minwidth: 120 },
        { prop: "shname", label: "客户名称" },
        { prop: "name", label: "货物名称" },
        { prop: "coaddress", label: "装货地址" },
        { prop: "enaddress", label: "卸货地址" },
        //{ prop: "starttime", label: "开始时间" },
        { prop: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "ton", label: "运送重量", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "inton", label: "装货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "unton", label: "卸货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "", label: "派送订单", slot: 'buttonPD' },
        { prop: "", label: "审核", slot: 'button' },
        { prop: "is_tax", label: "是否含税", slot: 'is_tax' },
      ],
      allBtnWidth: 128,
      btns: [
        {
          title: '查看统计',
          img: require('@/assets/img/icon_count.png'),
          unimg: require('@/assets/img/icon_count_hover.png'),
          //class:'countbtn',
          cb: ({ id }) => {
            this.$router.push(
              `/contract/statistics?id=${id}`
            );
          },
        },
        {
          title: '订单列表',
          //icon: 'el-icon-s-order',
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ id }) => {
            this.$router.push(
              `/contract/orderlist?id=${id}`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/contract/detail?id=${id}&mode=edit`
            );
          },
        },
      ],
      baseParams: ['isstatus'],
      title: '车辆列表',
      modalSearchForm: {},
      modalSearchFormCtrl: [
        {
          label: "",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
        },
      ],
      mform: {},
      mformCtrl: [
        {
          label: "",
          keyName: "dprice",
          err: "在此输入运费单",
          type: "number",
          unit: "元",
        },
      ],
      modalSubmitUrl: 'addorder',
      cars: [],
      checkedLists: [],
      checked: false,
    };
  },
  methods: {
    onCheckChange1(v) {
      console.log(v)
    },
    dispatch(row) {
      console.log(row)
      // return
      this.mform.contractid = row.id
      this.showDialog()
    },
    add() {
      this.$router.push(
        `/contract/detail?mode=add`
      );
    },
    checkConfirm({ id }) {
      this.$confirm('完成通过后不可撤销，是否通过完成?', '通过完成', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.checkReq(id);
      }).catch(() => { });
    },
    checkReq(id) {
      this.loading = true
      let url = `${this.baseUrl}/updateisstatus`;
      const params = {
        userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '出错了！'
        });
      })
    },
    getCars() {
      this.cars = []
      let url = `${this.baseUrl}/addcar`;
      const params = {
        userid: this.user.id,
      }
      const object = this.modalSearchForm
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key) && object[key]) {
          params[key] = object[key];
        }
      }
      // console.log(url, params)
      this.post(url, params, ({ car }) => {
        if (car && car.length) {
          this.cars = car
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSearchFormChange({ key, value }) {
      // console.log(key, value)
      this.modalSearchForm[key] = value;
      // console.log({ ...this.modalSearchForm })
    },
    onModalSearchReset() {
      this.modalSearchForm = {}
      this.getCars()
    },
    onCheckChange(v) {
      // console.log(v)
      this.mform.carlist = v
    },
    modalSubmitConfirm() {
      if (!this.mform.carlist || !this.mform.carlist.length) {
        this.$message({
          type: 'error',
          message: '请选择车辆！'
        });
        return
      }

      if (this.checked) {
        this.$set(this.mform, 'is_commission', 1)
      } else {
        this.$set(this.mform, 'is_commission', 0)
      }

      // console.log({ ...this.form });
      this.$confirm('请再次确认所派车辆是否有提成？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(this.onModalSubmit).catch(() => { });
    },
  },
  mounted() {
    this.getList()
    this.getCars()
  },
};
</script>

<style lang="less" scoped>
.dialog {
  /deep/ .el-dialog {
    width: 830px;
  }

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .searchForm {
    display: flex;

    /deep/ .el-form-item {
      margin: 0;

      .el-form-item__content {
        .el-input {
          input {
            background: #fff;
          }
        }
      }

      &:not(:first-of-type) {
        margin-left: 15px;
      }
    }
  }

  .modalForm {
    // position: absolute;
    // right: 20px;
    // top: 84px;

    /deep/ .el-form-item {
      .el-form-item__content {
        .el-input {
          input {
            width: 170px;
            padding-right: 40px;
            background: #fff;
          }
        }

        .unit {
          position: absolute;
          right: 10px;
        }
      }
    }
  }

  .list {
    // display: flex;
    // flex-wrap: wrap;
    height: 450px;

    // /deep/ .el-scrollbar__wrap {
    //   overflow-x: hidden;
    // }

    // /deep/ .is-horizontal {
    //   display: none;
    // }

    .item {
      width: 186px;
      margin: 0 15px 15px 0;
      background: #FAFAFA;
      position: relative;

      &:nth-child(4n) {
        margin-right: 0;
      }

      /deep/ .el-checkbox__input {
        position: absolute;
        right: 14px;
        top: 15px;
      }

      /deep/ .el-checkbox__label {
        padding: 0;
        width: 100%;
      }

      .row0 {
        padding: 0 13px;
        border-bottom: 1px solid #EBEEF5;
        display: flex;

        .col0 {
          height: 44px;
          line-height: 44px;
          font-size: 14px;
          color: #303133;
        }

        .col1 {
          height: 44px;
          line-height: 44px;
          margin: 0 0 0 10px;
          font-size: 14px;
          color: #C0C4CC;
        }

        .checkbox {
          position: absolute;
          right: 14px;
          top: 15px;

          /deep/ .el-checkbox__label {
            display: none;
          }
        }
      }

      .row1 {
        height: 34px;
        line-height: 34px;
        margin: 0 13px;
        font-size: 14px;
        color: #C0C4CC;
        // background: url(../images/icon_option_01.png) no-repeat right center;
        background-size: 16px
      }
    }
  }

  .btns {
    text-align: center;
    margin: 40px auto 20px;
  }
}

/deep/ .countbtn:hover {
  background: url(/assets/img/icon_option_01.png) no-repeat right center;
  background-size: 26px;
}

/deep/ .el-table .pr30 .cell {
  padding-right: 30px;
}
</style>
